import React, { Component } from 'react'
import 'react-vis/dist/style.css'
import * as moment from 'moment'
import momenttz from 'moment-timezone'
import { withStyles } from 'material-ui/styles'
import { Button, Grid, Typography } from 'material-ui'
import TextField from 'material-ui/TextField'
import IconButton from 'material-ui/IconButton'
import ChevronLeftIcon from 'material-ui-icons/ChevronLeft'
import ChevronRightIcon from 'material-ui-icons/ChevronRight'
import AlchemyTimelineDaily from './AlchemyTimelineDaily'
import AlchemyTimelineWeekly from './AlchemyTimelineWeekly'
import AlchemyTimelineMonthly from './AlchemyTimelineMonthly'
import '../modals/modal.css'

const styles = theme => ({
  tooltipContent: {
    background: 'white',
    border: 1,
    color: 'black',
    padding: 10
  },
  container: {
    display: 'flex',
    flexWrap: 'wrap'
  },
  textField: {
    margin: theme.spacing.unit,
    marginRight: theme.spacing.unit,
    width: 80
  },
  textInputBig: {
    color: 'silver'
  },
  textFilterNoBg: {
    flex: 1,
    color: 'rgba(0,0,0,0.12)'
  },
  textFilterGeryNoBg: {
    flex: 1,
    color: 'lightgrey'
  }
})

@withStyles(styles)
class AlchemyTimeline extends Component {
  constructor(props) {
    super(props)
    this.state = {
      dailyDate: moment().format('l'),
      status: 'daily'
    }
    this.nextDay = this.nextDay.bind(this)
    this.prevDay = this.prevDay.bind(this)
    this.setToday = this.setToday.bind(this)
  }

  setToday = () => {
    this.setState({
      dailyDate: moment().format('l')
    })
  }

  prevDay = () => {
    const prevDayNo = moment(new Date(this.state.dailyDate)).subtract(1, 'day')
    this.setState({
      dailyDate: prevDayNo.format('l')
    })
  }

  nextDay = () => {
    const nextDayNo = moment(new Date(this.state.dailyDate)).add(1, 'day')
    this.setState({
      dailyDate: nextDayNo.format('l')
    })
  }
  prevWeek = () => {
    const prevWeekNo = moment(new Date(this.state.dailyDate)).subtract(
      1,
      'week'
    )
    this.setState({
      dailyDate: prevWeekNo.format('l')
    })
  }

  nextWeek = () => {
    const nextWeekNo = moment(new Date(this.state.dailyDate)).add(1, 'week')
    this.setState({
      dailyDate: nextWeekNo.format('l')
    })
  }
  prevMonth = () => {
    const prevMonthNo = moment(new Date(this.state.dailyDate)).subtract(
      1,
      'month'
    )
    this.setState({
      dailyDate: prevMonthNo.format('l')
    })
  }

  nextMonth = () => {
    const nextMonthNo = moment(new Date(this.state.dailyDate)).add(1, 'month')
    this.setState({
      dailyDate: nextMonthNo.format('l')
    })
  }

  handleChange = name => event => {
    switch (name) {
      case 'date':
        this.setState({
          dailyDate: momenttz
            .tz(event.target.value, 'America/Los_Angeles')
            .format('l')
        })
        break

      default:
        break
    }
  }

  handleStatus = status => {
    this.setState({ status: status })
  }

  render() {
    const { classes } = this.props

    const weeks = [0, 1, 2, 3, 4]

    return (
      <div>
        <div className="divTextNoBg">
          <Typography
            onClick={() => this.handleStatus('daily')}
            variant="caption"
            className={
              this.state.status === 'daily'
                ? classes.textFilterNoBg
                : classes.textFilterGeryNoBg
            }
          >
            Daily
          </Typography>
          <Typography
            onClick={() => this.handleStatus('weekly')}
            variant="caption"
            className={
              this.state.status === 'weekly'
                ? classes.textFilterNoBg
                : classes.textFilterGeryNoBg
            }
          >
            Weekly
          </Typography>
          <Typography
            onClick={() => this.handleStatus('monthly')}
            variant="caption"
            className={
              this.state.status === 'monthly'
                ? classes.textFilterNoBg
                : classes.textFilterGeryNoBg
            }
          >
            Monthly
          </Typography>
        </div>
        {this.state.status === 'weekly' && (
          <div>
            <div
              id="switch-weeks"
              style={{
                width: '100%',
                marginLeft: '0%',
                marginRight: '0%'
              }}
            >
              <Grid
                container
                direction="row"
                justify="center"
                alignItems="baseline"
                spacing={0}
              >
                <Grid item xs={2} />
                <Grid item xs={2}>
                  <IconButton
                    onClick={() => this.prevWeek()}
                    disabled={this.state.isPaused}
                    className="btn btn-default btn-style"
                  >
                    <ChevronLeftIcon style={{ fontSize: 30 }} />
                  </IconButton>
                </Grid>
                <Grid item xs={4}>
                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center'
                    }}
                  >
                    <span style={{ fontSize: 10 }}>
                      {moment(new Date(this.state.dailyDate)).format('ddd')}
                    </span>
                    <TextField
                      id="date_select"
                      label={''}
                      type="date"
                      value={moment(new Date(this.state.dailyDate)).format(
                        'YYYY-MM-DD'
                      )}
                      className={classes.textField}
                      onChange={this.handleChange('date')}
                      InputProps={{
                        className: classes.textInputBig,
                        disableUnderline: true
                      }}
                    />
                  </div>
                </Grid>
                <Grid item xs={2}>
                  <IconButton
                    onClick={() => this.nextWeek()}
                    disabled={this.state.isPaused}
                    className="btn btn-default btn-style"
                  >
                    <ChevronRightIcon style={{ fontSize: 30 }} />
                  </IconButton>
                </Grid>
                <Grid item xs={2}>
                  {moment(new Date(this.state.dailyDate)).format('l') ===
                  moment().format('l') ? (
                    ''
                  ) : (
                    <Button
                      onClick={() => this.setToday()}
                      className={classes.icon}
                      size="small"
                    >
                      <span style={{ fontSize: 10 }}>Today</span>
                    </Button>
                  )}
                </Grid>
              </Grid>
            </div>
            {weeks.map((i, index) => (
              <AlchemyTimelineWeekly
                key={index}
                dayS={moment(new Date(this.state.dailyDate))
                  .subtract(i, 'weeks')
                  .startOf('week')
                  .format()}
                dayE={moment(new Date(this.state.dailyDate))
                  .subtract(i, 'weeks')
                  .endOf('week')
                  .format()}
                width={
                  window.innerWidth < 630 * 1.2
                    ? window.innerWidth * 1.24
                    : 630 * 1.2
                }
                height={
                  window.innerWidth < 630 * 1.2
                    ? window.innerWidth * 0.76
                    : 480 * 1.2
                }
              />
            ))}
          </div>
        )}
        {this.state.status === 'monthly' && (
          <div>
            <div
              id="switch-months"
              style={{
                width: '100%',
                marginLeft: '0%',
                marginRight: '0%'
              }}
            >
              <Grid
                container
                direction="row"
                justify="center"
                alignItems="baseline"
                spacing={0}
              >
                <Grid item xs={2} />
                <Grid item xs={2}>
                  <IconButton
                    onClick={() => this.prevMonth()}
                    disabled={this.state.isPaused}
                    className="btn btn-default btn-style"
                  >
                    <ChevronLeftIcon style={{ fontSize: 30 }} />
                  </IconButton>
                </Grid>
                <Grid item xs={4}>
                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center'
                    }}
                  >
                    <span style={{ fontSize: 10 }}>
                      {moment(new Date(this.state.dailyDate)).format('ddd')}
                    </span>
                    <TextField
                      id="date_select"
                      label={''}
                      type="date"
                      value={moment(new Date(this.state.dailyDate)).format(
                        'YYYY-MM-DD'
                      )}
                      className={classes.textField}
                      onChange={this.handleChange('date')}
                      InputProps={{
                        className: classes.textInputBig,
                        disableUnderline: true
                      }}
                    />
                  </div>
                </Grid>
                <Grid item xs={2}>
                  <IconButton
                    onClick={() => this.nextMonth()}
                    disabled={this.state.isPaused}
                    className="btn btn-default btn-style"
                  >
                    <ChevronRightIcon style={{ fontSize: 30 }} />
                  </IconButton>
                </Grid>
                <Grid item xs={2}>
                  {moment(new Date(this.state.dailyDate)).format('l') ===
                  moment().format('l') ? (
                    ''
                  ) : (
                    <Button
                      onClick={() => this.setToday()}
                      className={classes.icon}
                      size="small"
                    >
                      <span style={{ fontSize: 10 }}>Today</span>
                    </Button>
                  )}
                </Grid>
              </Grid>
            </div>
            <AlchemyTimelineMonthly
              dayS={moment(new Date(this.state.dailyDate))
                .startOf('month')
                .format()}
              dayE={moment(new Date(this.state.dailyDate))
                .endOf('month')
                .format()}
              width={
                window.innerWidth < 630 * 1.2
                  ? window.innerWidth * 1.24
                  : 630 * 1.2
              }
              height={
                window.innerWidth < 630 * 1.2
                  ? window.innerWidth * 0.76
                  : 480 * 1.2
              }
            />
          </div>
        )}
        {this.state.status === 'daily' && (
          <div>
            <div
              id="switch-weeks"
              style={{
                width: '100%',
                marginLeft: '0%',
                marginRight: '0%'
              }}
            >
              <Grid
                container
                direction="row"
                justify="center"
                alignItems="baseline"
                spacing={0}
              >
                <Grid item xs={2} />
                <Grid item xs={2}>
                  <IconButton
                    onClick={() => this.prevDay()}
                    disabled={this.state.isPaused}
                    className="btn btn-default btn-style"
                  >
                    <ChevronLeftIcon style={{ fontSize: 30 }} />
                  </IconButton>
                </Grid>
                <Grid item xs={4}>
                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center'
                    }}
                  >
                    <span style={{ fontSize: 10 }}>
                      {moment(new Date(this.state.dailyDate)).format('ddd')}
                    </span>
                    <TextField
                      id="date_select"
                      label={''}
                      type="date"
                      value={moment(new Date(this.state.dailyDate)).format(
                        'YYYY-MM-DD'
                      )}
                      className={classes.textField}
                      onChange={this.handleChange('date')}
                      InputProps={{
                        className: classes.textInputBig,
                        disableUnderline: true
                      }}
                    />
                  </div>
                </Grid>
                <Grid item xs={2}>
                  <IconButton
                    onClick={() => this.nextDay()}
                    disabled={this.state.isPaused}
                    className="btn btn-default btn-style"
                  >
                    <ChevronRightIcon style={{ fontSize: 30 }} />
                  </IconButton>
                </Grid>
                <Grid item xs={2}>
                  {moment(new Date(this.state.dailyDate)).format('l') ===
                  moment().format('l') ? (
                    ''
                  ) : (
                    <Button
                      onClick={() => this.setToday()}
                      className={classes.icon}
                      size="small"
                    >
                      <span style={{ fontSize: 10 }}>Today</span>
                    </Button>
                  )}
                </Grid>
              </Grid>
            </div>

            <AlchemyTimelineDaily
              dayS={moment(new Date(this.state.dailyDate))
                .startOf('day')
                .format()}
              dayE={moment(new Date(this.state.dailyDate))
                .endOf('day')
                .format()}
              width={
                window.innerWidth < 630 * 1.2
                  ? window.innerWidth * 1.24
                  : 630 * 1.2
              }
              height={
                window.innerWidth < 630 * 3
                  ? window.innerWidth * 3 * 0.76
                  : 480 * 2
              }
              type={'timelineTracker'}
              goal={''}
              action={(d, t) =>
                t === 'add' ? this.handleOpenAdd(d) : this.handleOpenView(d)
              }
            />
            <div
              id="switch-weeks"
              style={{
                width: '100%',
                marginLeft: '0%',
                marginRight: '0%'
              }}
            >
              <Grid
                container
                direction="row"
                justify="center"
                alignItems="baseline"
                spacing={0}
              >
                <Grid item xs={2} />
                <Grid item xs={2}>
                  <IconButton
                    onClick={() => this.prevDay()}
                    disabled={this.state.isPaused}
                    className="btn btn-default btn-style"
                  >
                    <ChevronLeftIcon style={{ fontSize: 30 }} />
                  </IconButton>
                </Grid>
                <Grid item xs={4}>
                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center'
                    }}
                  >
                    <span style={{ fontSize: 10 }}>
                      {moment(new Date(this.state.dailyDate)).format('ddd')}
                    </span>
                    <TextField
                      id="date_select"
                      label={''}
                      type="date"
                      value={moment(new Date(this.state.dailyDate)).format(
                        'YYYY-MM-DD'
                      )}
                      className={classes.textInputBig}
                      onChange={this.handleChange('date')}
                    />
                  </div>
                </Grid>
                <Grid item xs={2}>
                  <IconButton
                    onClick={() => this.nextDay()}
                    disabled={this.state.isPaused}
                    className="btn btn-default btn-style"
                  >
                    <ChevronRightIcon style={{ fontSize: 30 }} />
                  </IconButton>
                </Grid>
                <Grid item xs={2}>
                  {moment(new Date(this.state.dailyDate)).format('l') ===
                  moment().format('l') ? (
                    ''
                  ) : (
                    <Button
                      onClick={() => this.setToday()}
                      className={classes.icon}
                      size="small"
                    >
                      <span style={{ fontSize: 10 }}>Today</span>
                    </Button>
                  )}
                </Grid>
              </Grid>
            </div>
          </div>
        )}
      </div>
    )
  }
}

export default AlchemyTimeline



// WEBPACK FOOTER //
// ./src/components/ChartTypes/AlchemyTimeline.js